import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue } from 'vue-property-decorator';

var TopUpRecordDetailPage = function (_super) {
  __extends(TopUpRecordDetailPage, _super);

  function TopUpRecordDetailPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.data = null;
    return _this;
  }

  TopUpRecordDetailPage.prototype.queryRechargeDetail = function (param) {
    return __awaiter(this, void 0, void 0, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.finance.queryRechargeDetail(param)];

          case 1:
            data = _a.sent().data;
            this.data = data;
            return [2];
        }
      });
    });
  };

  TopUpRecordDetailPage.prototype.queryTariffRechargeDetail = function () {
    return __awaiter(this, void 0, void 0, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.finance.queryTariffTopUpDetail({
              id: String(this.$route.query.orderId)
            })];

          case 1:
            data = _a.sent().data;
            this.data = this.mappingDetails(data);
            return [2];
        }
      });
    });
  };

  TopUpRecordDetailPage.prototype.mappingDetails = function (data) {
    return {
      order_number: data.order_number,
      account_code: data.account_code,
      sign_business_type_list_text: '',
      transaction_status_text: data.transaction_status_text,
      transaction_type_text: data.transaction_type_text,
      sign_body_name: data.sign_body_name,
      service_body_name: data.service_body_name,
      customer_code: data.customer_code,
      add_time: data.create_time,
      payee_time: data.payee_time,
      bank_name: data.drawee_bank,
      drawee: data.drawee,
      drawee_account: data.drawee_bank_account,
      third_party_payment_platform_text: '',
      payee_name: data.payee_name,
      payee_bank_name: data.payee_bank_name,
      payee_account: data.payee_account,
      recharge_code: data.recharge_currency_code,
      register_amount: data.register_amount,
      exchange: data.exchange_rate,
      reference_number: data.refer_number,
      currency_code: data.currency_code,
      arrival_amount: data.arrival_amount
    };
  };

  TopUpRecordDetailPage.prototype.created = function () {
    var pageType = 'tariff';

    if (this.$route.query.pageType === pageType) {
      this.queryTariffRechargeDetail();
    } else {
      this.queryRechargeDetail({
        order_id: String(this.$route.query.orderId)
      });
    }
  };

  TopUpRecordDetailPage = __decorate([Component], TopUpRecordDetailPage);
  return TopUpRecordDetailPage;
}(Vue);

export default TopUpRecordDetailPage;